import styled from 'styled-components'

export const DialogContent = styled.div`
  padding: 0 0 60px 0;
`
export const CellLongString = styled.span`
  word-break: break-all;
`
